import { Component } from '@angular/core';

@Component({
  selector: 'oes-spinner',
  templateUrl: 'spinner.component.html',
  styleUrls: ['spinner.component.scss']
})
export class SpinnerComponent {
  constructor() {}
}
